import classNames from 'classnames'
import classes from './Options.module.scss'

const Options = ({ children, secondary, style }) => {
  return (
    <div className={classNames(classes['options'], style)}>
      <div
        className={classNames(
          classes['options__buttons'],
          secondary && classes['options__buttons--secondary'],
        )}
      >
        {children}
      </div>
    </div>
  )
}

Options.Item = ({ onChange, value, label, checked, name, style, id, disabled, isInformative }) => {
  // Ensure a unique, predictable id for the input/label association.
  // Prefer explicit id, else derive from the group name and value.
  const safe = (str) => String(str).replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-_:.]/g, '')
  const inputId = id ? safe(id) : name ? `${safe(name)}--${safe(value)}` : safe(value)

  return (
    <div 
      className={classNames(
        classes['btn'], 
        style, 
        disabled && classes['btn--disabled'],
        isInformative && classes['btn--informative']
      )} 
      key={value}
    >
      <input
        key={value}
        type="radio"
        id={inputId}
        name={name}
        onChange={onChange}
        value={value}
        checked={checked}
        disabled={disabled}
      />
      <label className="h5" htmlFor={inputId}>
        {label}
      </label>
    </div>
  )
}

export default Options
